document.addEventListener('DOMContentLoaded', () => {

    const section = document.querySelector('.cherlux-lookbook');

    if (!section) return;

    const tabs = section.querySelectorAll('.cherlux-lookbook__tab');
    const images = section.querySelectorAll('.cherlux-lookbook__image');
    const panels = section.querySelectorAll('.cherlux-lookbook__product-panel');

    tabs.forEach(tab => {

        tab.addEventListener('click', () => {

            const index = tab.dataset.look;

            /* Remove active state from everything */
            tabs.forEach(button => {
                button.classList.remove('is-active');
            });

            images.forEach(image => {
                image.classList.remove('is-active');
            });

            panels.forEach(panel => {
                panel.classList.remove('is-active');
            });

            /* Activate clicked tab */
            tab.classList.add('is-active');

            /* Activate matching image */
            section
                .querySelector(
                    `.cherlux-lookbook__image[data-look="${index}"]`
                )
                ?.classList.add('is-active');

            /* Activate matching product panel */
            section
                .querySelector(
                    `.cherlux-lookbook__product-panel[data-look="${index}"]`
                )
                ?.classList.add('is-active');

        });

    });

});